<template>
	<section id="dashboard-ecommerce">
		<b-row class="match-height">
			<b-col sm="12" md="12" lg="12" xl="12">
				<filters @selectedFilter="applyFiltersEvent($event)"></filters>
			</b-col>
		</b-row>
		<b-row class="match-height">
			<b-col lg="12">
				<b-row class="match-height">
					<b-col sm="12" md="12" lg="12" xl="12">
						<b-card no-body class="mb-0">
							<b-overlay :show="isFetchingRecordsFromServer" :variant="'transparent'" :opacity="'1'" :blur="'2px'" rounded="sm">

								<b-card-header>
									<b-card-title>Lifetime Totals</b-card-title>
								</b-card-header>

								<b-table ref="refUserListTable" class="position-relative p-1" :items="tableSiteListArray" responsive :fields="tableColumnsArray" primary-key="id" show-empty empty-text="No records found">

									<template #cell(total_emails)="data">
										<feather-icon v-if="data.item.total_emails === undefined || data.item.total_emails === null" icon="LoaderIcon" size="18" class="spinner" />
    									<span v-else>{{ data.item.total_emails }}</span>
									</template>

								</b-table>

								<b-row>
									<b-col cols="12 mb-1 d-flex justify-content-center" v-if="this.selectedFilters.selectedSite == ''">
										<b-overlay :show="disabledLoadMoreButton" :variant="'transparent'" :opacity="'1'" :blur="'2px'" rounded="sm">
											<b-button type="button" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="" @click="lodeMoreRecords" v-if="hideLoadMoreButton">
												Load More
											</b-button>
										</b-overlay>
									</b-col>
								</b-row>

							</b-overlay>
						</b-card>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</section>
</template>

<script>
	import {
		BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BLink, BOverlay, BButton, BTable
	} from "bootstrap-vue";

	import Filters from "./Filter.vue";
	import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

	export default {
		components: {
			BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BLink, BOverlay, BButton, BTable,
			Filters,
		},
		data() {
			return {
				isFetchingRecordsFromServer: false,
				statisticsFilterData: {},
				tableColumnsArray: [
					{ key: 'siteURL', label: 'Site URL' },
					{ key: 'total_emails', label: 'Total Push Email' },
				],
				tableSiteListArray: [],
				siteListArray: [],
				records_start: 0,
				selectedFilters: {},
				fetchSiteConversionsRequest: 0,
				disabledLoadMoreButton: 0,
				hideLoadMoreButton: true,
			};
		},
		watch: {
			fetchSiteConversionsRequest(newVal) {
				this.disabledLoadMoreButton = newVal;
			}
		},
		methods: {
			lodeMoreRecords() {
				let takenSites = _.take(_.drop(this.siteListArray, this.records_start), 10); /* GET ONLY 10 ROWS */
				/* FOR HIDE LOAD MORE BUTTON : START */
				if (_.isEmpty(takenSites)) {
					this.hideLoadMoreButton = false;
					return false;
				}
				/* FOR HIDE LOAD MORE BUTTON : END */

				this.records_start += 10;
				this.tableSiteListArray.push(...takenSites); /* ADD 10 ROWS INTO TABLE ARRAY */

				let site_ids = [];
				takenSites.forEach(siteObj => {
					site_ids.push(siteObj.siteId);
				});
				this.fetchSiteConversions(site_ids);
			},
			applyFiltersEvent(filterObject) {

				/* RESET LODE MORE RECORDS : START */
				this.siteListArray = [];
				this.tableSiteListArray = [];
				this.records_start = 0;
				/* RESET LODE MORE RECORDS : END */

				this.selectedFilters = filterObject; /* ADD FILERTS TO OBJECT */

				/* SET ALL SITES TO SITE ARRAY AND LOAD FIRST 10 RECORDS : START */
				this.siteListArray = _.map(filterObject.sites, function (obj) {
					obj.total_emails = null
					return obj;
				});
				this.lodeMoreRecords();
				/* SET ALL SITES TO SITE ARRAY AND LOAD FIRST 10 RECORDS : END */

			},
			fetchSiteConversions(site_ids) {
				this.fetchSiteConversionsRequest++;
				this.isFetchingRecordsFromServer = true;
				this.$reportAPI.post('fetch-sites-drip-emails', {
					'auth_id': this.$root.authUserObject.id ?? '',
					'site_ids': site_ids ?? '',
					'date_type': this.selectedFilters.date_type ?? '',
					'custom_start_date': (this.selectedFilters.date_type_custom ? this.selectedFilters.date_type_custom.start : ''),
					'custom_end_date': (this.selectedFilters.date_type_custom ? this.selectedFilters.date_type_custom.end : ''),
				}).then((response) => {
					response = response.data;
					if (response.status) {
						let drip_sites = _.keyBy(response.drip_sites, 'siteId');
						this.tableSiteListArray = this.tableSiteListArray.map((obj) => {
							if (site_ids.includes(obj.siteId)) {
								obj.total_emails = drip_sites[obj.siteId] ? drip_sites[obj.siteId]['total_leads'] : 0;
							}
							return obj;
						});
					} else {
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Notification',
								icon: 'BellIcon',
								variant: 'danger',
								text: response.message,
							},
						});
					}
					this.fetchSiteConversionsRequest--;
					this.isFetchingRecordsFromServer = false;
				});
			}
		},
		created() { },
		setup() { },
	};
</script>